module.exports = __webpack_public_path__ + "img/zan.058f341b.png";